import type { HTMLAttributes, ReactNode } from 'react';

interface LtrProps extends Omit<HTMLAttributes<HTMLElement>, 'dir'> {
  children: ReactNode;
}

/**
 * Left-to-right island inside Hebrew text (DESIGN_SYSTEM.md §18): emails, phone numbers,
 * codes, URLs, IDs and numbers with signs or units. Renders `<bdi dir="ltr">`, which is
 * bidi-isolated, so "054-1234567" or "a.b@c.co" keep their order and do not reorder the
 * Hebrew words around them. Inline, no styling of its own.
 *
 * For editable LTR data use `dir="ltr"` on the input itself, not this wrapper.
 */
export default function Ltr({ children, ...rest }: LtrProps) {
  return (
    <bdi dir="ltr" {...rest}>
      {children}
    </bdi>
  );
}
